<template>
  <div class="recover-password">
    <AlertBar
      class="recover-password__alert"
      v-model="message.show"
      :type="message.type"
      :message="message.text"
      :detail="message.detail"
    ></AlertBar>
    <Busy :value="busy"></Busy>
    <v-container
      class="d-flex align-center justify-center"
      fluid
      fill-height
      @mousedown.stop
      @keydown.stop
    > <!-- The .stops prevent the App.vue keepalives from firing on this page since we are not in a session yet -->
      <template v-if="!emailSent">
        <v-card class="recover-password-card elevation-12 align-self-center justify-self-center ma-6 pa-6">
          <v-card-title>
            Recover password
          </v-card-title>      
          <v-card-subtitle>
            Don't worry, we'll have you back up in no time!
          </v-card-subtitle>
          <v-card-text>
            <v-form
              ref="form"
              @submit.prevent="requestPasswordReset"
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    prepend-icon="person"
                    name="emailField"
                    id="emailField"
                    label="Email"
                    type="text"
                    v-model="email"
                    :rules="[ rules.required, rules.validEmail ]"
                    hide-details="auto"
                    placeholder=" "
                    persistent-placeholder
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="action-button"
              color="primary"
              @click="requestPasswordReset"
              type="submit"
            >email me a recovery link</v-btn>
          </v-card-actions>
        </v-card>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12" class="text-center align-center justify-center">
            <div class="pa-4 ma-4 text-center align-center justify-center">
              <v-icon size="64" color="success" left class="pr-1">fa-solid fa-circle-check</v-icon>
              <span class="text-h4 font-weight-black">Success!</span>
            </div>
            <div class="text-center text-h5 pa-4 ma-4">
              A password reset email has been sent. Please click the link when you receive it.
            </div>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </div>
</template>

<script>
import { AlertBar, Busy, ExceptionMessage, Rules } from '@itus/ui.common'

export default {
  name: 'RecoverPassword',
  data() {
    return {
      email : '',
      busy: false,
      message: {
        show: false,
        type: 'error',
        text: ''
      },
      rules: Rules,
      emailSent: false
    }
  },
  components: {
    AlertBar,
    Busy
  },
  methods: {
    showException(err, defaultMsg) {
      this.message = ExceptionMessage.generateMessage(err, defaultMsg)
    },
    async requestPasswordReset() {
      if(!this.$refs.form.validate())
        return

      try {
        this.busy = true
        await this.$store.dispatch('requestResetPassword', { email: this.email })
        this.emailSent = true
      } catch(err) {
        this.showException(err, "Error requesting a password reset.")
      } finally {
        this.busy = false
      }
    }
  },
  mounted() {
    this.emailSent = false
  }
}
</script>
<style lang="scss" scoped>
.recover-password {
  height: 100%;  
}
.recover-password__alert {
  position: fixed;
  width: 100%;
  z-index: 1;
}
.recover-password-card {
  min-width: 300px;
}
.action-button {
  width: 100%;
}
</style>